import { Pipe, PipeTransform } from "@angular/core";
@Pipe({ name: "limitTo" })
export class limitToPipe implements PipeTransform {
  transform(
    data: any,
    length: number,
    index: number,
    changeIndex: number
  ): any {
    if (changeIndex === undefined) {
      changeIndex = index;
    }
    if (data.length > 4 && changeIndex === index) {
      return data.slice(0, length);
    } else {
      if (changeIndex === index) {
        return data;
      } else {
        return data.slice(0, 4);
      }
    }
  }
}
